module.exports = __webpack_public_path__ + "img/han_jie_gong_zuo_zhan-icon2.ed25d6e4.png";